namespace MACRAIL.Forms {

/**
 * Create and show a modal dialog easily.
 */
export class TabbedForm {

    private container: JQuery;

    private opts: any;

    /**
     * Create a new TabbedForm.
     *
     * @constructor
     * @param container New TabbedForm container.
     */
    constructor (opts: any)
    {
        let self = this;

        this.opts = opts;

        if (this.opts.minSidebarPosition) {
            this.opts.minSidebarPosition = Math.floor(this.opts.minSidebarPosition);
        } else {
            this.opts.minSidebarPosition = 0;
        }

        this.container = opts.container;

        this.container.find('.tabbedform-buttons').on('click', '.tabbedform-button', function() {
            self.setTab($(this).data('id'));
        });

        // Stick the buttons
        $(document).on('scroll', function() {
            self.repositionSidebar();
        });

    }

    public setOption(name: string, value: any)
    {
        this.opts[name] = value;
    }

    public setTab(id: string)
    {
        this.container.find('.tabbedform-button').removeClass('tabbedform-button-active');

        if (this.opts.singleTab) {
            this.container.find('.tabbedform-tab').hide();
            this.getTab(id).show();
        } else {
            $('html,body').animate({
                'scrollTop': ((this.getTab(id).offset().top) - this.opts.minSidebarPosition),
            }, 'slow');
        }
    }

    public updateTabStatuses()
    {
        // Set tab formatting.
        // HACK: This is pretty horrible (checking the DOM???) but will do for now.

        let tabs = this.container.find('.tabbedform-tab');

        tabs.each((i, tab) => {
            let $tab = $(tab);
            let tabId = $tab.data('id');

            $tab.removeClass('has-error has-warning');

            let fieldCount = $tab.find('.tabbedform-form-alert-container:visible').length;
            let warnings = $tab.find('.has-warning').length;
            let dangers = $tab.find('.has-error').length;
            let clean = $tab.find('.clean:visible').length;

            this.setTabWidget(tabId, 'warning', warnings);
            this.setTabWidget(tabId, 'danger', dangers);

            if (dangers > 0) {
                this.setTabStatus(tabId, 'danger');
            } else if (warnings > 0) {
                this.setTabStatus(tabId, 'warning');
            } else {
                if (clean || fieldCount === 0) {
                    this.setTabStatus(tabId, 'default');
                } else {
                    this.setTabStatus(tabId, 'success');
                }
            }
        });
    }

    public setTabStatus(id: string, status: string)
    {
        this.getButton(id)
            // tslint:disable-next-line:max-line-length
            .removeClass('tabbedform-button-status-success tabbedform-button-status-warning tabbedform-button-status-danger')
            .addClass(`tabbedform-button-status-${status}`);
        this.getTab(id)
            .removeClass('box-default box-success box-warning box-danger')
            .addClass(`box-${status}`);
    }

    public setTabWidget(id: string, status: string, count: number)
    {
        let button = this.getButton(id);

        if (button.find('.tabbedform-button-widgets').length === 0) {
            button.prepend(`
                <div class="tabbedform-button-widgets">
                    <div class="widget widget-xxxs widget-warning" style="display: none;">0</div>
                    <div class="widget widget-xxxs widget-danger" style="display: none;">0</div>
                </div>
            `);
        }

        let widget = button.find(`.widget-${status}`);

        widget.text(count);
        if (count > 0) {
            widget.show();
        } else {
            widget.hide();
        }
    }

    public hideTab(id: string)
    {
        this.getTab(id).addClass('tabbedform-tab-hide');
        this.getButton(id).hide();
    }

    public showTab(id: string)
    {
        this.getTab(id).removeClass('tabbedform-tab-hide');
        this.getButton(id).show();
    }

    public repositionSidebar()
    {
        let minPos = this.opts.minSidebarPosition;

        let pos = Math.floor($('.tabbedform-tabs').offset().top - $(document).scrollTop());

        $('.tabbedform-sidebar').css('top', pos > minPos ? pos : minPos);
    }

    private getButton(id: string)
    {
        return this.container.find(`.tabbedform-button[data-id="${id}"]`);
    }

    private getTab(id: string)
    {
        return this.container.find(`.tabbedform-tab[data-id="${id}"]`);
    }
}

}
